import { render, staticRenderFns } from "./NewAttendanceData.vue?vue&type=template&id=d71ba928"
import script from "./NewAttendanceData.vue?vue&type=script&lang=js"
export * from "./NewAttendanceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports